import React from 'react';

import { OPENING_HOURS } from '../../constants/openingHours';
import './OpeningHoursContent.css';

export const OpeningHoursContent = (): JSX.Element => {
    return (
        <div className="footer-opening-hours">
            {OPENING_HOURS.map((entry) => (
                <p key={entry.period} className="footer-opening-hours__entry">
                    <strong>{entry.period}</strong>
                    {entry.hours.map((line) => (
                        <React.Fragment key={line}>
                            <br />
                            {line}
                        </React.Fragment>
                    ))}
                </p>
            ))}
        </div>
    );
};
